export default __webpack_public_path__ + "static/media/AZ-DPD-logo.a0dbbb71.png";